module.exports = __webpack_public_path__ + "img/8.bf1c6a88.svg";